<hdi-page>
  <hdi-spinner *ngIf="isLoading" />
  <header class="header">
    <hdi-meta-bar [metaMenu]="metaMenu" *ngIf="metaMenu"></hdi-meta-bar>
    <hdi-top-bar
      [metaMenu]="metaMenu"
      [mainMenu]="mainMenu"
      [flyoutData]="flyoutData"
    ></hdi-top-bar>
  </header>

  <main class="main">
    <router-outlet></router-outlet>
  </main>

  <footer>
    <div class="container">
      <hdi-footer [caasData]="footer"></hdi-footer>
    </div>
  </footer>
  <hdi-to-top-button></hdi-to-top-button>
</hdi-page>

<hdi-modal
  *ngIf="video"
  [type]="ModalType.VIDEO"
  [videoSrc]="video.videoSrc"
  [videoId]="video.videoId"
  [showModal]="showModal"
  [thumbnailSrc]="video.thumbnailSrc"
  (closeModalTrigger)="closeModal($event)"
>
  <div class="header-content">
    <ng-content select=".header-content"></ng-content>
  </div>
  <ng-content></ng-content>
</hdi-modal>
